import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ChipAndLabel = ({color, children, sx}) => (
  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
    <Box
      sx={[
        theme => ({
          backgroundColor: () => {
            // use a washed out "ligter" color
            const base =
              theme.vars.palette[color]?.light ??
              `color-mix(in srgb, ${color[500]}, white 40%)`;

            // add transparency
            return `color-mix(in srgb, ${base}, transparent 70%)`;
          },
          border: 'solid 2px',
          borderColor: theme.vars.palette[color]?.main ?? color[500],
          display: 'inline-block',
          height: '1.25em',
          width: '1.25em',
          minWidth: '1.25em',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
    <Typography component="span" variant="subtitle2">
      {children}
    </Typography>
  </Box>
);

ChipAndLabel.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default ChipAndLabel;
